// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wgMM_6HO3Cj5IodggSFO{display:inline-flex;margin-right:.5em}.MX9zE5qYHjzMcVS3hAmv,.Va3rxUQFi_KsH43kYSeK{width:15px;height:15px;margin-right:.2em;border-radius:2px}.MX9zE5qYHjzMcVS3hAmv{background-color:#000}.Va3rxUQFi_KsH43kYSeK{background-color:#ddd;border-color:#000;border-style:solid;border-width:1px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blocksContainer": `wgMM_6HO3Cj5IodggSFO`,
	"blockFilled": `MX9zE5qYHjzMcVS3hAmv`,
	"blockEmpty": `Va3rxUQFi_KsH43kYSeK`
};
module.exports = ___CSS_LOADER_EXPORT___;
